import { Dialog, DialogContent } from '@mui/material';
import { toImageSrc } from '../utils/imageProxy';

const OpenImageDialog = ({ openImage, setOpenImage, profileUrl }) => {
    const resolvedUrl = toImageSrc(profileUrl);
    const handleClose = () => setOpenImage(false);

    return (
        <Dialog open={openImage} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogContent>
                <img src={resolvedUrl} alt="Aperçu" style={{ width: '100%' }} loading="lazy" decoding="async" />
            </DialogContent>
        </Dialog>
    );
};

export default OpenImageDialog;
